import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    cardContainer: {
        padding: '20px'
    }

}))

export default useStyles